import { computed } from '@vue/composition-api'
import { useConfirmation } from '@/modules/kisweui/compositions'
import { useCurrentTeam } from '@/modules/teams/compositions'
import { TeamGroupActionParams } from '@/types/teams'
import { sortBy, pickBy } from 'lodash'
import { KeyDict } from '@/types'
import { UserProfile } from '@/types/users'
import store from '@/store'
import { KisweModalMode } from '@/modules/kisweui/types'

const addTeamGroup = async ({ group, userIds }: TeamGroupActionParams) => {
  try {
    await store.dispatch.team.addTeamGroup({ group, userIds })
  } catch (error) {
    console.error('Error addEditDone add member group', error)
  }
}

const editTeamGroup = async ({ group, userIds, teamGroupId }: TeamGroupActionParams) => {
  try {
    await store.dispatch.team.editTeamGroup({ group: { ...group, id: teamGroupId }, userIds })
  } catch (error) {
    console.error('Error addEditDone update member group', error)
  }
}

const requestTeamGroupAction = async (actionType: KisweModalMode, actionParams: TeamGroupActionParams) => {
  const { group, userIds, teamGroupId } = actionParams
  if (actionType === KisweModalMode.Create) {
    await addTeamGroup({ group, userIds })
  } else if (actionType === KisweModalMode.Edit) {
    await editTeamGroup({ group, userIds, teamGroupId })
  }
}

const useTeamGroups = () => {
  const { askConfirmation } = useConfirmation()
  const { currentTeamMembers } = useCurrentTeam()
  const activeTeam = computed(() => store.state.team.activeTeam)
  const newTeamGroup = computed(() => ({ team_id: activeTeam.value, name: '', description: '' }))
  const teamGroups = computed(() =>
    sortBy(store.state.team.teamGroups, (group) => group.name.toLowerCase()))
  const groupMembers = computed(() => {
    return teamGroups.value.reduce((allGroups: KeyDict<KeyDict<UserProfile>>, currentGroup) => {
      if (currentGroup.id) {
        allGroups[currentGroup.id] = pickBy(currentTeamMembers.value,
          (user) => user.teamGroups[activeTeam.value]?.includes(currentGroup.id!)
        )
      }
      return allGroups
    }, {})
  })

  const deleteTeamGroup = async (groupId?: string) => {
    if (!groupId) return
    await askConfirmation({
      question: 'Are you sure you want to delete this team?',
      action: async () => {
        await store.dispatch.team.removeTeamGroup(groupId)
      },
      title: 'Delete team',
      options: {
        confirmButtonText: 'Delete'
      }
    })
  }

  return {
    deleteTeamGroup,
    groupMembers,
    newTeamGroup,
    requestTeamGroupAction,
    teamGroups
  }
}

export default useTeamGroups
